import React, { useState, useTransition } from "react";
import { TypeAnimation } from "react-type-animation";

const Greet = () => {
  let myDate = new Date();
  let hours = myDate.getHours();
  let greet;

  if (hours < 12) greet = "Morning";
  else if (hours >= 12 && hours <= 17) greet = "Afternoon";
  else if (hours >= 17 && hours <= 24) greet = "Evening";

  // eslint-disable-next-line
  const [isPending, startTransition] = useTransition();

  const [isVisible, setIsVisible] = useState(true);
  const timer = setTimeout(() => {
    startTransition(() => {
      setIsVisible(false);
    });

    return () => clearTimeout(timer);
  }, [7000]);

  return (
    <div>
      {isVisible ? (
        <div className="bg-purple-100 dark:bg-slate-900 dark:text-white p-5 m-5 sm:flex sm:justify-center sm:flex-row-reverse rounded-3xl">
          <div className="text-center type-animation-fix">
            <TypeAnimation
              sequence={[
                // Same substring at the start will only be typed out once, initially
                `< Good ${greet}! />`,
                1200, // wait 1s before replacing "Mice" with "Hamsters"
                `< Welcome to My Profile />`,
                1000,
              ]}
              wrapper="span"
              speed={40}
              style={{
                fontSize: "1.25rem",
                display: "inline-block",
                fontWeight: "bold",
                backgroundColor: "transparent",
              }}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Greet;
